<script setup>
import { onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { getI18n } from '@/plugins/i18n'

import { useDetectDevice } from '@/composables/device'
import { menuRoutes, menuRouteEnum } from '@/router'
import { infoBoxIdEnum } from '@/stores/portal.store'

import InfoBox from '@/components/shared/InfoBox.vue'
import WarehouseAvailabilityPivotGrid from '@/components/planner/WarehouseAvailabilityPivotGrid.vue'

const i18n = getI18n()
const router = useRouter()
const { isMobile } = useDetectDevice()

onMounted(() => {
  if (isMobile.value) router.replace(menuRoutes[menuRouteEnum.WAREHOUSE_STOCK])
})
</script>

<template>
  <div>
    <warehouse-availability-pivot-grid />
    <info-box :id="infoBoxIdEnum.AVAILABILITY_PIVOT" class="q-mt-md" :message="i18n.t('common.availabilityPivotHint')" />
  </div>
</template>
